import type {
  GetChannelInfoForCommentsQuery,
  SavedReply,
  Service,
  CommentStatus,
} from '~publish/gql/graphql'

import type { CommentsChannelNav } from '~publish/components/CommentsSidebar/useCommentsChannels'

export type Feature = 'comments' | 'engage'

export interface SupportedChannel {
  service: Service
  type: string[]
}

export interface FeatureChannels {
  feature: Feature
  supportedChannels: SupportedChannel[]
}

export type ChannelType =
  | CommentsChannelNav
  | GetChannelInfoForCommentsQuery['channel']

export type SavedReplyId = SavedReply['id']

export type CommentTab = 'overview' | 'comments'

export const availableTabs: CommentTab[] = ['comments']
export const DEFAULT_TAB: CommentTab = 'comments'

// Extend the GraphQL CommentStatus with 'all' for UI purposes
export type CommentStatusWithAll = CommentStatus | 'all'

// Type-safe comment status constants
export const COMMENT_STATUS = {
  All: 'all',
  New: 'new',
  Replied: 'replied',
  Unreplied: 'unreplied',
  Dismissed: 'dismissed',
} as const satisfies Record<string, CommentStatusWithAll>
